const Loader = () => {
  return (
    <div
      className="flex justify-center space-x-2 2xl:space-x-4"
      aria-hidden="true"
    >
      <div
        style={{
          backgroundColor: "#2ea2fa",
        }}
        className="h-5 w-5 2xl:h-10 2xl:w-10 rounded-full animate-loader"
      />
      <div
        style={{
          backgroundColor: "#8ce218",
          animationDelay: "0.2s",
        }}
        className="h-5 w-5 2xl:h-10 2xl:w-10 rounded-full animate-loader"
      />
      <div
        style={{
          backgroundColor: "#ff8888",
          animationDelay: "0.4s",
        }}
        className="h-5 w-5 2xl:h-10 2xl:w-10 rounded-full animate-loader"
      />
    </div>
  );
};

const Loading = () => {
  return (
    <div
      className="fixed z-10 inset-0 overflow-hidden bg-slate-800 h-screen"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-center h-full">
        <Loader />
        <span className="sr-only">Loading content, please wait...</span>
      </div>
    </div>
  );
};

export default Loading;
